import { render, staticRenderFns } from "./AisleTransferIcon.vue?vue&type=template&id=0074a255&scoped=true"
import script from "./AisleTransferIcon.vue?vue&type=script&lang=ts"
export * from "./AisleTransferIcon.vue?vue&type=script&lang=ts"
import style0 from "./AisleTransferIcon.vue?vue&type=style&index=0&id=0074a255&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0074a255",
  null
  
)

export default component.exports